// extracted by mini-css-extract-plugin
export default {"kioskCreateButton":"kiosks_kioskCreateButton__gcBCY"};